import { CARD_BACKGROUND_COLOR_PATH } from '@wix/communities-blog-client-common';
import withSettingsColor from './with-settings-color';

export default withSettingsColor(CARD_BACKGROUND_COLOR_PATH, 'cardBackgroundColor');
